import Vue from "vue";
import VueRouter from "vue-router";
import axios from "../axios";
import store from "../store/index";

Vue.use(VueRouter);

async function verificationRouter(to, from, next) {
  await axios.get(`/auth/me`).then((response) => {
    store.state.userName = response.data.name_user;
    store.state.authCode = response.status;
    store.state.authUser.id_profile_user = response.data.id_profile_user;
    store.state.authUser.id_unity_user = response.data.unity.id;
    store.state.authUser.unity_name = response.data.unity.unity_name;

       // se a API devolver as habilidades
    store.state.authUser.abilities = response.data.abilities || [];
  });

  if (from.path == "/") {
    store.state.stepperPatient = true;
    store.state.stepperVisitors = false;
    store.state.authUser.fullName = "";
  }
  // if (to.path == "/users" && store.state.authUser.id_profile_user != 1) {
  //   next("/dashboard");
  // }

  if (store.state.authCode == 200) {
    next();
  } else {
    next("/");
  }
}

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  // PERFIL
  {
    path: "/Perfis",
    beforeEnter: verificationRouter,
    component: () => import("../views/PesquisarMovi.vue"),
    children: [
      {
        path: "",
        name: "LIsta de Perfis",
        component: () => import("../components/profiles/GridProfiles.vue"),
      },
    ],
  },

  {
    path: "/PesquisarMovi",
    beforeEnter: verificationRouter,
    component: () => import("../views/PesquisarMovi.vue"),
    children: [
      {
        path: "",
        name: "Pesquisar Movimentação de Visitantes e Acompanhantes",
        component: () =>
          import("../components/movivisitaacomp/PesquisarMovi-comp.vue"),
      },
    ],
  },
  {
    path: "/admVisitorsMovi",
    beforeEnter: verificationRouter,
    component: () => import("../views/VisitanteAdmMovi.vue"),
    children: [
      {
        path: "",
        name: "Pesquisar Movimentação dos Visitantes Administrativos",
        component: () =>
          import("../components/movivisitaacomp/admVisitorsMovi.vue"),
      },
    ],
  },

  {
    path: "/VisualizarMovi",
    beforeEnter: verificationRouter,
    component: () => import("../views/VisualizarMovi.vue"),
    children: [
      {
        path: "",
        name: "Visualizar Movimentação de Visitantes e Acompanhantes",
        component: () =>
          import("../components/movivisitaacomp/VisualizarMovi-comp.vue"),
      },
    ],
  },

  {
    path: "/PacieAmbu",
    beforeEnter: verificationRouter,
    component: () => import("../views/PacieAmbu.vue"),
    children: [
      {
        path: "",
        name: "Pesquisar Pacientes",
        component: () =>
          import("../components/movimentacao/PacieAmbu-comp.vue"),
      },
    ],
  },

  {
    path: "/dashboard",
    beforeEnter: verificationRouter,
    component: () => import("../views/Dashboard.vue"),
    children: [
      {
        path: "",
        name: "Dashboard",
        component: () => import("../components/dashboard/Dashboard-comp.vue"),
      },
    ],
  },
  {
    path: "/escala-trabalhada",
    beforeEnter: verificationRouter,
    component: () => import("../views/WorkSchedule.vue"),
    children: [
      {
        path: "",
        name: "Escala Trabalhada",
        component: () =>
          import("../components/work-schedule/WorkSchedule-comp.vue"),
      },
    ],
  },
  {
    path: "/person",
    beforeEnter: verificationRouter,
    component: () => import("../views/Person.vue"),
    children: [
      {
        path: "",
        name: "Pesquisar Paciente",
        component: () =>
          import("../components/person/patient/SearchPatient.vue"),
      },
    ],
  },
  {
    path: "/adm-person",
    beforeEnter: verificationRouter,
    component: () => import("../views/Visitante.vue"),
    children: [
      {
        path: "",
        name: "Visitante Administrativo",
        component: () =>
          import("../components/person/admVisitors/TableVisitorsAdm.vue"),
      },
    ],
  },
  {
    path: "/cad-adm-person",
    beforeEnter: verificationRouter,
    component: () => import("../views/Visitante.vue"),
    children: [
      {
        path: "",
        name: "Visitante Administrativo",
        component: () =>
          import("../components/person/admVisitors/AdmVisitors.vue"),
      },
    ],
  },
  {
    path: "/users",
    name: "users",
    beforeEnter: verificationRouter,
    component: () => import("../views/Usuarios.vue"),
    children: [
      {
        path: "",
        name: "Lista de Usuários",
        component: () => import("../components/users/Table-comp.vue"),
      },
    ],
  },
  {
    path: "/visitSector",
    name: "Setor Visitante",
    beforeEnter: verificationRouter,
    component: () => import("../views/SetorVisitante.vue"),
    children: [
      {
        path: "",
        name: "Lista de Setores",
        component: () => import("../components/visitSector/VisitSector.vue"),
      },
    ],
  },

  // {
  //   path: "/visitantType",
  //   name: "Tipo de Visitante",
  //   beforeEnter: verificationRouter,
  //   component: () => import("../views/VisitantType.vue"),
  //   children: [
  //     {
  //       path: "",
  //       name: "Tipo de Visitante",
  //       component: () => import("../components/visitantType/VisitantType.vue"),
  //     },
  //   ],
  // },
  {
    path: "/visitProfessional",
    name: "Visita Profissional",
    beforeEnter: verificationRouter,
    component: () => import("../views/VisitaProfissional.vue"),
    children: [
      {
        path: "",
        name: "Lista de Visitas Profissionais",
        component: () =>
          import("../components/visitProfessional/VisitProfessional.vue"),
      },
    ],
  },
  {
    path: "/log",
    name: "Logs",
    beforeEnter: verificationRouter,
    component: () => import("../views/VisitaProfissional.vue"),
    children: [
      {
        path: "",
        name: "Lista de LOG de usuarios",
        component: () => import("../components/users/UsersLog.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
